/**
 * Brazilian Portuguese translations of backend response messages, keyed by the
 * exact English text the backend sends (CustomError / success messages).
 * Single source of truth for FE and BE localization — the frontend loads
 * this as the i18next 'backend' namespace; unknown messages pass through.
 */
export const backendMessagesPt: Record<string, string> = {
  '(#133010) Account not registered': '(#133010) Conta não registrada',
  '2FA has been successfully disabled for your account.':
    'A 2FA foi desabilitada com sucesso para a sua conta.',
  '2FA has been successfully enabled for your account.':
    'A 2FA foi habilitada com sucesso para a sua conta.',
  '2FA is already enabled for this user':
    'A 2FA já está habilitada para este usuário',
  '2FA is not enabled for this user':
    'A 2FA não está habilitada para este usuário',
  '2FA not configured correctly': 'A 2FA não está configurada corretamente',
  '2FA setup initiated. Please verify to complete setup.':
    'Configuração de 2FA iniciada. Verifique para concluir a configuração.',
  '2FA setup not found. Please initiate 2FA setup first.':
    'A configuração de 2FA não foi encontrada. Inicie primeiro a configuração de 2FA.',
  '2FA status retrieved successfully.': 'Status da 2FA obtido com sucesso.',
  '2FA token required': 'O token de 2FA é obrigatório',
  'A contact book entry is identified by the WhatsApp user ID of the contact, for example BD.1068713429041673.':
    'Uma entrada da agenda de contatos é identificada pelo ID de usuário do WhatsApp do contato, por exemplo BD.1068713429041673.',
  'A positive "take" value (limit) is required for pagination.':
    'É necessário um valor "take" (limite) positivo para a paginação.',
  'A valid business must be present in the request token to attach credit line':
    'Deve haver uma empresa válida no token da solicitação para vincular a linha de crédito',
  'AI results retrieved successfully': 'Resultados de IA obtidos com sucesso',
  'API key added successfully': 'Chave de API adicionada com sucesso',
  'API key deleted successfully': 'Chave de API excluída com sucesso',
  'API key has been revoked': 'A chave de API foi revogada',
  'API key not found': 'Chave de API não encontrada',
  'API key revoked successfully': 'Chave de API revogada com sucesso',
  'API keys retrieved successfully': 'Chaves de API obtidas com sucesso',
  'Access Token not found': 'Token de acesso não encontrado',
  'Access Token not valid': 'Token de acesso inválido',
  'Access denied': 'Acesso negado',
  'Access denied. VPC only.': 'Acesso negado. Somente VPC.',
  'Account already exists': 'A conta já existe',
  'Analytics data is temporarily unavailable, please try again shortly':
    'Os dados de análise estão temporariamente indisponíveis, tente novamente em breve',
  'Active API key set successfully': 'Chave de API ativa definida com sucesso',
  'Active bots retrieved successfully': 'Bots ativos obtidos com sucesso',
  'Active call already exists for this client':
    'Já existe uma chamada ativa para este cliente',
  'An update is already in progress for this function. Please wait a moment and try again.':
    'Já há uma atualização em andamento para esta função. Aguarde um momento e tente novamente.',
  'App not found!': 'Aplicativo não encontrado!',
  'At least one of subject, description, or profile picture file is required':
    'É necessário pelo menos um destes: assunto, descrição ou arquivo de foto de perfil',
  'At least one of tags or attributes must be provided':
    'É preciso fornecer pelo menos um destes: etiquetas ou atributos',
  'Copilot chats are tied to a signed-in user and are not available to API keys.':
    'Os chats do Copilot estão vinculados a um usuário com sessão iniciada e não estão disponíveis para chaves de API.',
  'Invalid session id': 'Id de sessão inválido',
  'This chat has newer messages on another device. Reload to catch up before saving.':
    'Este chat tem mensagens mais recentes em outro dispositivo. Recarregue para atualizar antes de salvar.',
  'audio file is required': 'O arquivo de áudio é obrigatório',
  Transcribed: 'Transcrito',
  'Transcription failed': 'A transcrição falhou',
  'Authenticated email missing': 'Falta o e-mail autenticado',
  'Authentication required.': 'É necessária autenticação.',
  'Authorization header is required.':
    'O cabeçalho Authorization é obrigatório.',
  "Authorization header must be formatted as 'Bearer [token]'.":
    "O cabeçalho Authorization deve estar no formato 'Bearer [token]'.",
  'Authorization successful.': 'Autorização bem-sucedida.',
  'Balance added successfully': 'Saldo adicionado com sucesso',
  'before and beforeId must each be a single value':
    'before e beforeId devem ser, cada um, um único valor',
  'before must be a valid ISO timestamp':
    'before deve ser uma marca de tempo ISO válida',
  'beforeId must be sent together with before':
    'beforeId deve ser enviado junto com before',
  'Bill ID is required.': 'O ID da fatura é obrigatório.',
  'Bill deleted successfully.': 'Fatura excluída com sucesso.',
  'Bill fetched successfully.': 'Fatura obtida com sucesso.',
  'Bill not found.': 'Fatura não encontrada.',
  'Bill updated successfully.': 'Fatura atualizada com sucesso.',
  'Billing data generated successfully.':
    'Dados de faturamento gerados com sucesso.',
  'Bills fetched successfully.': 'Faturas obtidas com sucesso.',
  'Blocked clients fetched successfully':
    'Clientes bloqueados obtidos com sucesso',
  'Books mapping fetched.': 'Mapeamento do Books obtido.',
  'Books mapping is not enabled for this business.':
    'O mapeamento do Books não está habilitado para esta empresa.',
  'Books mapping updated.': 'Mapeamento do Books atualizado.',
  'Bot results retrieved successfully': 'Resultados do bot obtidos com sucesso',
  'Business Account ID or FB Access Token is missing!':
    'Falta o Business Account ID ou o FB Access Token!',
  'Business has no Meta access token configured':
    'A empresa não tem um token de acesso da Meta configurado',
  'Business has no WhatsApp phone number configured':
    'A empresa não tem um número de telefone do WhatsApp configurado',
  'Business ID is required': 'O ID da empresa é obrigatório',
  'Business WhatsApp credentials not configured':
    'As credenciais do WhatsApp da empresa não estão configuradas',
  'Business deleted successfully!': 'Empresa excluída com sucesso!',
  'Business details are missing. Please add business details first!':
    'Faltam os dados da empresa. Adicione primeiro os dados da empresa!',
  'Business details are missing. Please add business details first.':
    'Faltam os dados da empresa. Adicione primeiro os dados da empresa.',
  'Business details are missing. Please complete WhatsApp setup first.':
    'Faltam os dados da empresa. Conclua primeiro a configuração do WhatsApp.',
  'Business details are missing. So please add first business details!':
    'Faltam os dados da empresa. Adicione primeiro os dados da empresa!',
  'Business does not have a Facebook Access Token.':
    'A empresa não tem um token de acesso do Facebook.',
  'Business does not have a Facebook App ID. So please add Facebook App ID in WhatsApp API Setup!':
    'A empresa não tem um Facebook App ID. Adicione o Facebook App ID nas configurações da API do WhatsApp!',
  'Business has no orgId': 'A empresa não tem orgId',
  'Business name updated successfully!':
    'Nome da empresa atualizado com sucesso!',
  'Business not found': 'Empresa não encontrada',
  'Business not found in your organization.':
    'Empresa não encontrada na sua organização.',
  'Business not found or does not belong to this organization':
    'Empresa não encontrada ou não pertence a esta organização',
  'Business not found or does not belong to this partner.':
    'Empresa não encontrada ou não pertence a este parceiro.',
  'Business not found!': 'Empresa não encontrada!',
  'Business not found.': 'Empresa não encontrada.',
  'Business phone number is not configured correctly':
    'O número de telefone da empresa não está configurado corretamente',
  'Business setup correctly not found':
    'Não foi encontrada uma configuração correta da empresa',
  'Business setup is incomplete': 'A configuração da empresa está incompleta',
  'Business setup is incomplete. Missing fbAccessToken or businessAccountId.':
    'A configuração da empresa está incompleta. Falta fbAccessToken ou businessAccountId.',
  'Business updated successfully': 'Empresa atualizada com sucesso',
  'Call accepted successfully!': 'Chamada aceita com sucesso!',
  'Call initiated successfully!': 'Chamada iniciada com sucesso!',
  'Call messages retrieved successfully':
    'Mensagens da chamada obtidas com sucesso',
  'Call pre-accepted successfully!': 'Chamada pré-aceita com sucesso!',
  'Call rejected successfully!': 'Chamada recusada com sucesso!',
  'Call terminated successfully': 'Chamada finalizada com sucesso',
  'Call terminated successfully!': 'Chamada finalizada com sucesso!',
  'Campaign not found': 'Campanha não encontrada',
  'Cannot Verify Webhook Token!':
    'Não é possível verificar o token do webhook!',
  'Cannot delete $LATEST version': 'Não é possível excluir a versão $LATEST',
  'Cannot delete a business with completed setup. Only incomplete setups can be deleted.':
    'Não é possível excluir uma empresa com a configuração concluída. Só é possível excluir configurações incompletas.',
  'Cannot delete the last business. At least one business is required.':
    'Não é possível excluir a última empresa. É necessária pelo menos uma empresa.',
  'Cannot revoke — at least one OWNER must retain access to each business.':
    'Não é possível revogar — pelo menos um OWNER deve manter acesso a cada empresa.',
  'Cannot use "after" and "before" cursors simultaneously.':
    'Não é possível usar os cursores "after" e "before" ao mesmo tempo.',
  'Chat completion successful': 'Chat completion bem-sucedido',
  'Chatbot assigned to client successfully':
    'Bot atribuído ao cliente com sucesso',
  'Chatbot assignment removed from client':
    'Atribuição do bot removida do cliente',
  'Chatbot config retrieved': 'Configuração do bot obtida',
  'Chatbot conversation triggered successfully':
    'Conversa do bot ativada com sucesso',
  'Chatbot created successfully': 'Bot criado com sucesso',
  'Chatbot deleted successfully': 'Bot excluído com sucesso',
  'Chatbot exported successfully': 'Bot exportado com sucesso',
  'Chatbot imported successfully': 'Bot importado com sucesso',
  'Chatbot not found': 'Bot não encontrado',
  'Chatbot nudges fetched successfully': 'Lembretes do bot obtidos com sucesso',
  'Chatbot response generated successfully':
    'Resposta do bot gerada com sucesso',
  'Chatbot retrieved successfully': 'Bot obtido com sucesso',
  'Chatbot updated successfully': 'Bot atualizado com sucesso',
  'Chatbots retrieved successfully': 'Bots obtidos com sucesso',
  'ClickHouse analytics is not enabled':
    'A análise do ClickHouse não está habilitada',
  'ClickHouse is not available': 'O ClickHouse não está disponível',
  'ClickHouse is unavailable; cannot generate bills.':
    'O ClickHouse não está disponível; não é possível gerar faturas.',
  'Client chat status updated successfully':
    'Status do chat do cliente atualizado com sucesso',
  'Client has not opted in': 'O cliente não deu consentimento',
  'Client is blocked': 'O cliente está bloqueado',
  'Client not found': 'Cliente não encontrado',
  'Clients created/updated successfully':
    'Clientes criados/atualizados com sucesso',
  'Code executed': 'Código executado',
  'Code executed successfully': 'Código executado com sucesso',
  'Code saved successfully': 'Código salvo com sucesso',
  'Coexistence is not enabled for this business!':
    'A coexistência não está habilitada para esta empresa!',
  'Compressed payload too large': 'O payload compactado é grande demais',
  'Contact not found': 'Contato não encontrado',
  'Contact updated successfully.': 'Contato atualizado com sucesso.',
  'Copilot response received': 'Resposta do Copilot recebida',
  'Cost analytics retrieved successfully':
    'Análise de custo obtida com sucesso',
  'Could not find whatsapp_business_messaging scope with target_ids in granular_scopes':
    'O escopo whatsapp_business_messaging com target_ids não foi encontrado em granular_scopes',
  'Could not prepare storage for upload. Please try again.':
    'Não foi possível preparar o armazenamento para o upload. Tente novamente.',
  'Could not resolve a contact from the given identifiers':
    'Não foi possível resolver um contato a partir dos identificadores fornecidos',
  'Credit line attached successfully': 'Linha de crédito vinculada com sucesso',
  'Currency conversion failed.': 'Falha na conversão de moeda.',
  'Daily engagement analytics retrieved successfully':
    'Análise de interação diária obtida com sucesso',
  'Debug context retrieved': 'Contexto de depuração obtido',
  'Edit lock status': 'Status do bloqueio de edição',
  'Either phoneNumberId or businessId, clientWaNumber, and either text or messages are required':
    'É necessário phoneNumberId ou businessId, clientWaNumber, e text ou messages',
  'Either text, media, or a button/list reply must be provided':
    'É preciso fornecer texto, mídia ou uma resposta de botão/lista',
  'Email is required': 'O e-mail é obrigatório',
  'Email is required!': 'O e-mail é obrigatório!',
  'Email verified. Your account is ready — please log in.':
    'E-mail verificado. Sua conta está pronta — faça login.',
  'Embed session created.': 'Sessão de incorporação criada.',
  'Employee not found': 'Funcionário não encontrado',
  'Employee not found!': 'Funcionário não encontrado!',
  'Employee record not found': 'Registro de funcionário não encontrado',
  'Error 500': 'Erro 500',
  'Error during message search': 'Erro durante a busca de mensagens',
  'Error fetching business profile details!':
    'Erro ao obter os detalhes do perfil da empresa!',
  'Error in JWT Token!': 'Erro no token JWT!',
  'Error in SSO authorization.': 'Erro na autorização SSO.',
  'Error in authorization.': 'Erro na autorização.',
  'Error in embedded signup': 'Erro no cadastro integrado',
  'Error in fetching single flow': 'Erro ao obter o fluxo',
  'Error updating business profile details!':
    'Erro ao atualizar os detalhes do perfil da empresa!',
  'Error while marking message as read': 'Erro ao marcar a mensagem como lida',
  'Estimate details fetched successfully.':
    'Detalhes do orçamento obtidos com sucesso.',
  'Estimate marked as accepted.': 'Orçamento marcado como aceito.',
  'Estimate not found.': 'Orçamento não encontrado.',
  'Execution role is not configured. Please contact support.':
    'A função de execução não está configurada. Entre em contato com o suporte.',
  Forbidden: 'Proibido',
  'Facebook Access Token not found':
    'Token de acesso do Facebook não encontrado',
  'Failed to accept call': 'Não foi possível aceitar a chamada',
  'Failed to attach credit line for this business':
    'Não foi possível vincular a linha de crédito para esta empresa',
  'Failed to create Karix account for credit line':
    'Não foi possível criar a conta da Karix para a linha de crédito',
  'Failed to create flow': 'Não foi possível criar o fluxo',
  'Failed to create template': 'Não foi possível criar o modelo',
  'Failed to create template with library. Please contact customer support':
    'Não foi possível criar o modelo com a biblioteca. Entre em contato com o suporte ao cliente',
  'Failed to create template. Please contact customer support':
    'Não foi possível criar o modelo. Entre em contato com o suporte ao cliente',
  'Failed to create versioned function.':
    'Não foi possível criar a função versionada.',
  'Failed to delete hash templates': 'Não foi possível excluir os modelos hash',
  'Failed to delete template': 'Não foi possível excluir o modelo',
  'Failed to delete the flow': 'Não foi possível excluir o fluxo',
  'Failed to delete version': 'Não foi possível excluir a versão',
  'Failed to deprecate the flow':
    'Não foi possível marcar o fluxo como obsoleto',
  'Failed to fetch JsonFlow': 'Não foi possível obter o JsonFlow',
  'Failed to fetch analytics': 'Não foi possível obter a análise',
  'Failed to fetch call settings':
    'Não foi possível obter as configurações de chamadas',
  'Failed to fetch conversation analytics':
    'Não foi possível obter a análise de conversas',
  'Failed to fetch data localization region from Meta.':
    'Não foi possível obter a região de localização dos dados na Meta.',
  'Failed to fetch data localization region.':
    'Não foi possível obter a região de localização dos dados.',
  'Failed to fetch form responses due to a server error':
    'Não foi possível obter as respostas do formulário devido a um erro do servidor',
  'Failed to fetch meta acount health status!':
    'Não foi possível obter o estado de saúde da conta da Meta!',
  'Failed to fetch pricing analytics':
    'Não foi possível obter a análise de preços',
  'Failed to fetch template analytics':
    'Não foi possível obter a análise de modelos',
  'Failed to fetch whatsapp commerce settings':
    'Não foi possível obter as configurações de comércio do WhatsApp',
  'Failed to generate Karix token for credit line':
    'Não foi possível gerar o token da Karix para a linha de crédito',
  'Failed to generate system prompt. Please try again.':
    'Não foi possível gerar o prompt do sistema. Tente novamente.',
  'Failed to get response from AI. Please try again.':
    'Não foi possível obter resposta da IA. Tente novamente.',
  'Failed to initiate call': 'Não foi possível iniciar a chamada',
  'Failed to pre-accept call': 'Não foi possível pré-aceitar a chamada',
  'Failed to preview the flow': 'Não foi possível pré-visualizar o fluxo',
  'Failed to process templates': 'Não foi possível processar os modelos',
  'Failed to publish the flow': 'Não foi possível publicar o fluxo',
  'Failed to register phone number!':
    'Não foi possível registrar o número de telefone!',
  'Failed to reject call': 'Não foi possível recusar a chamada',
  'Failed to request coexistence sync!':
    'Não foi possível solicitar a sincronização de coexistência!',
  'Failed to retrieve template message analytics':
    'Não foi possível obter a análise de mensagens de modelo',
  'Failed to send typing indicator!':
    'Não foi possível enviar o indicador de digitação!',
  'Failed to subscribe to webhooks!':
    'Não foi possível se inscrever nos webhooks!',
  'Failed to terminate call': 'Não foi possível finalizar a chamada',
  'Failed to update call settings':
    'Não foi possível atualizar as configurações de chamadas',
  'Failed to update data localization region on Meta.':
    'Não foi possível atualizar a região de localização dos dados na Meta.',
  'Failed to update data localization region.':
    'Não foi possível atualizar a região de localização dos dados.',
  'Failed to update jwt token': 'Não foi possível atualizar o token jwt',
  'Failed to update template': 'Não foi possível atualizar o modelo',
  'Failed to update the flow': 'Não foi possível atualizar o fluxo',
  'Failed to update whatsapp commerce settings':
    'Não foi possível atualizar as configurações de comércio do WhatsApp',
  'Failed to upload through Resumable API':
    'Não foi possível enviar pela Resumable API',
  'Fallback config deleted successfully':
    'Configuração de fallback excluída com sucesso',
  'Fallback config not found': 'Configuração de fallback não encontrada',
  'Fallback config saved successfully':
    'Configuração de fallback salva com sucesso',
  'Fallback configs fetched successfully':
    'Configurações de fallback obtidas com sucesso',
  'Fetch flows error': 'Erro ao obter os fluxos',
  'Fetched data localization region.':
    'Região de localização dos dados obtida.',
  'Fetched function details': 'Detalhes da função obtidos',
  'Fetched versions': 'Versões obtidas',
  'Field name too long.': 'Nome de campo longo demais.',
  'Field value too long.': 'Valor de campo longo demais.',
  'File is required': 'O arquivo é obrigatório',
  'File not accessible': 'Arquivo não acessível',
  'File not found in request body!':
    'Arquivo não encontrado no corpo da solicitação!',
  'File too large. Please upload a smaller file.':
    'Arquivo grande demais. Envie um arquivo menor.',
  'File type and file name are required!':
    'O tipo e o nome do arquivo são obrigatórios!',
  'Filename is too long. Maximum 255 characters allowed.':
    'O nome do arquivo é longo demais. São permitidos no máximo 255 caracteres.',
  'Flow executed': 'Fluxo executado',
  'Function bundle not available': 'O pacote da função não está disponível',
  'Function executed successfully': 'Função executada com sucesso',
  'GST status fetched successfully.': 'Status do GST obtido com sucesso.',
  'GSTIN updated successfully.': 'GSTIN atualizado com sucesso.',
  'Graph API Error': 'Erro da Graph API',
  'Group deletion requested': 'Exclusão do grupo solicitada',
  'Group info retrieved': 'Informações do grupo obtidas',
  'Group settings update requested':
    'Atualização das configurações do grupo solicitada',
  'HTTP request executed': 'Solicitação HTTP executada',
  Hello: 'Olá',
  'Hello there': 'Olá',
  'Hello!': 'Olá!',
  Hi: 'Olá',
  'Hi there': 'Olá',
  'Incorrect or expired code. If it keeps failing, please start the sign-up again to get a new code.':
    'Código incorreto ou expirado. Se continuar falhando, inicie o cadastro novamente para obter um código novo.',
  'Invalid 2FA token': 'Token de 2FA inválido',
  'Invalid 2FA token. Please provide a valid token to disable 2FA.':
    'Token de 2FA inválido. Forneça um token válido para desabilitar a 2FA.',
  'Invalid 2FA token. Please try again.':
    'Token de 2FA inválido. Tente novamente.',
  'Invalid Google token': 'Token do Google inválido',
  'Invalid HTTP request options': 'Opções de solicitação HTTP inválidas',
  'Invalid Pipecat secret': 'Segredo do Pipecat inválido',
  'Invalid Web Verification Token': 'Token de verificação web inválido',
  'Invalid amount. Must be greater than 0.':
    'Valor inválido. Deve ser maior que 0.',
  'Invalid business ID': 'ID de empresa inválido',
  'Invalid business context': 'Contexto de empresa inválido',
  'Invalid business id.': 'ID de empresa inválido.',
  'Invalid config ID': 'ID de configuração inválido',
  'Invalid cursor format': 'Formato de cursor inválido',
  'Invalid date format. Expected YYYY-MM-DD format (e.g., "2025-11-01").':
    'Formato de data inválido. Esperado o formato YYYY-MM-DD (por exemplo, "2025-11-01").',
  'Invalid date format. Use YYYY-MM-DD':
    'Formato de data inválido. Use YYYY-MM-DD',
  'Invalid destination phone number': 'Número de telefone de destino inválido',
  'Invalid email or password': 'E-mail ou senha inválidos',
  'Invalid email or password2.': 'E-mail ou senha inválidos2.',
  'Invalid employee ID': 'ID de funcionário inválido',
  'Invalid filename. Please use a safe filename without special characters.':
    'Nome de arquivo inválido. Use um nome de arquivo seguro, sem caracteres especiais.',
  'Invalid message type': 'Tipo de mensagem inválido',
  'Invalid or missing orgId parameter.': 'Parâmetro orgId inválido ou ausente.',
  'Invalid org ID': 'ID de organização inválido',
  'Invalid request data': 'Dados da solicitação inválidos',
  'Invalid response data': 'Dados da resposta inválidos',
  'Invalid voice bot secret': 'Segredo do bot de voz inválido',
  'Invalid webhook signature': 'Assinatura de webhook inválida',
  'Invite link reset': 'Link de convite redefinido',
  'Invite link retrieved': 'Link de convite obtido',
  'Invite valid': 'Convite válido',
  'Invoice URL fetched successfully.': 'URL da fatura obtida com sucesso.',
  'Invoice is not available for this bill yet.':
    'A fatura ainda não está disponível para este período.',
  'Iteration complete': 'Iteração concluída',
  'Join requests approved': 'Solicitações de entrada aprovadas',
  'Join requests rejected': 'Solicitações de entrada recusadas',
  'Join requests retrieved': 'Solicitações de entrada obtidas',
  'Journey not found': 'Journey não encontrado',
  'Just one': 'Somente um',
  'KARIX_ACCESS_TOKEN is not configured':
    'KARIX_ACCESS_TOKEN não está configurado',
  'Legacy API key(s) revoked successfully':
    'Chave(s) de API legada(s) revogada(s) com sucesso',
  'Link successfully created.': 'Link criado com sucesso.',
  'Links successfully created.': 'Links criados com sucesso.',
  'Links successfully retrieved.': 'Links obtidos com sucesso.',
  'Live chatbots config updated successfully':
    'Configurações de bots ativos atualizadas com sucesso',
  'LiveKit agent name is not configured':
    'O nome do agente do LiveKit não está configurado',
  'LiveKit credentials are not configured':
    'As credenciais do LiveKit não estão configuradas',
  'Logged out successfully': 'Sessão encerrada com sucesso',
  'Message ID is required!': 'O ID da mensagem é obrigatório!',
  'Message marked as read!': 'Mensagem marcada como lida!',
  'Message not found': 'Mensagem não encontrada',
  'Message search is currently unavailable. Please try again later.':
    'A busca de mensagens não está disponível no momento. Tente novamente mais tarde.',
  'Message search timed out. Please refine your query and try again.':
    'A busca de mensagens excedeu o tempo limite. Refine sua consulta e tente novamente.',
  'Messages sent successfully': 'Mensagens enviadas com sucesso',
  'Meta agent not found': 'Agente da Meta não encontrado',
  'Meta AI is handling this chat. Only Meta can hand a conversation to a human — it does that on its own when it decides one is needed. To stop the agent everywhere, unpublish it.':
    'A Meta AI está cuidando deste chat. Somente a Meta pode passar uma conversa para uma pessoa, e ela faz isso por conta própria quando julga necessário. Para parar o agente em todos os chats, despublique-o.',
  'Missing X-Pipecat-Secret header': 'Falta o cabeçalho X-Pipecat-Secret',
  'Missing X-Voice-Bot-Secret header': 'Falta o cabeçalho X-Voice-Bot-Secret',
  'Missing authorization header': 'Falta o cabeçalho de autorização',
  'Missing edit session id': 'Falta o id da sessão de edição',
  'Models retrieved successfully': 'Modelos obtidos com sucesso',
  'Monitoring data fetched successfully':
    'Dados de monitoramento obtidos com sucesso',
  'No Meta AI agent is configured on this number yet':
    'Este número ainda não tem um agente da Meta AI configurado',
  'No Meta agent is active': 'Nenhum agente da Meta está ativo',
  'No SIP configuration found': 'Nenhuma configuração SIP encontrada',
  'No active LLM API key found. Please configure an API key first.':
    'Nenhuma chave de API de LLM ativa encontrada. Configure primeiro uma chave de API.',
  'No active call found': 'Nenhuma chamada ativa encontrada',
  'No active employee found to assign chat!':
    'Nenhum funcionário ativo encontrado para atribuir o chat!',
  'No billing configured for this organization.':
    'Não há faturamento configurado para esta organização.',
  'No billing data for this period.':
    'Não há dados de faturamento para este período.',
  'No business context — pass businessId or use a business-scoped JWT.':
    'Não há contexto de empresa — passe businessId ou use um JWT com escopo de empresa.',
  'No businesses found for this org':
    'Nenhuma empresa encontrada para esta organização',
  'No organizations found for this partner':
    'Nenhuma organização encontrada para este parceiro',
  'No call found for this callId':
    'Nenhuma chamada encontrada para este callId',
  'No call message found to update (early failure)':
    'Nenhuma mensagem de chamada encontrada para atualizar (falha antecipada)',
  'No chatbot available for this business':
    'Não há nenhum bot disponível para esta empresa',
  'No chatbotId provided and no active voice bot configured':
    'Nenhum chatbotId foi fornecido e não há um bot de voz ativo configurado',
  'No hash templates found to delete':
    'Nenhum modelo hash encontrado para excluir',
  'No org found': 'Organização não encontrada',
  'No organization is associated with this account.':
    'Não há nenhuma organização associada a esta conta.',
  'No responseData found in responseMiddleware':
    'responseData não encontrado no responseMiddleware',
  'No retainer invoice found for this estimate. Make sure the estimate has been accepted in Zoho first.':
    'Nenhuma fatura de adiantamento encontrada para este orçamento. Verifique se o orçamento foi aceito primeiro no Zoho.',
  'No templates found to process': 'Nenhum modelo encontrado para processar',
  'No valid message content': 'Não há conteúdo de mensagem válido',
  'No voice bot configured': 'Não há um bot de voz configurado',
  'Not Enabled.': 'Não habilitado.',
  'Not found.': 'Não encontrado.',
  'Nudge scheduled successfully': 'Lembrete agendado com sucesso',
  'OAuth client successfully created.': 'Cliente OAuth criado com sucesso.',
  'One or more chatbots do not belong to this organization':
    'Um ou mais bots não pertencem a esta organização',
  'Only an OWNER can manage business access.':
    'Somente um OWNER pode gerenciar o acesso à empresa.',
  'Only an OWNER can restore a deleted employee.':
    'Somente um OWNER pode restaurar um funcionário removido.',
  'Org ID or business id not found in JWT payload!':
    'O ID da organização ou o id da empresa não foi encontrado no payload do JWT!',
  'Org context missing in request':
    'Falta o contexto da organização na solicitação',
  'Org not found': 'Organização não encontrada',
  'Org pricing updated successfully.':
    'Preços da organização atualizados com sucesso.',
  'Org-level functions retrieved successfully':
    'Funções em nível de organização obtidas com sucesso',
  'Org-wide scope requires access to every business in the org.':
    'O escopo de toda a organização requer acesso a todas as empresas da organização.',
  'Org-wide scope is not available for this session.':
    'O escopo de toda a organização não está disponível para esta sessão.',
  'Template-wise cost analytics is only available per business':
    'A análise de custos por modelo só está disponível por empresa',
  'Org-wide account status is not available for this session.':
    'O status da conta de toda a organização não está disponível para esta sessão.',
  'Organization not found or does not belong to this partner.':
    'Organização não encontrada ou não pertence a este parceiro.',
  'Organization not found.': 'Organização não encontrada.',
  'Outbound call initiated': 'Chamada de saída iniciada',
  'PIPECAT_SECRET not configured': 'PIPECAT_SECRET não está configurado',
  'Participant removal requested': 'Remoção de participante solicitada',
  'Partner admin added successfully.':
    'Administrador do parceiro adicionado com sucesso.',
  'Partner admin not found.': 'Administrador do parceiro não encontrado.',
  'Partner admin removed successfully.':
    'Administrador do parceiro removido com sucesso.',
  'Partner admins fetched successfully.':
    'Administradores do parceiro obtidos com sucesso.',
  'Partner businesses fetched successfully.':
    'Empresas do parceiro obtidas com sucesso.',
  'Partner context fetched successfully.':
    'Contexto do parceiro obtido com sucesso.',
  'Partner context not found.': 'Contexto do parceiro não encontrado.',
  'Partner created successfully.': 'Parceiro criado com sucesso.',
  'Partner not found.': 'Parceiro não encontrado.',
  'Partner orgs fetched successfully.':
    'Organizações do parceiro obtidas com sucesso.',
  'Partner updated successfully.': 'Parceiro atualizado com sucesso.',
  'Partners fetched successfully.': 'Parceiros obtidos com sucesso.',
  'Password updated successfully!': 'Senha atualizada com sucesso!',
  'Patch result reported': 'Resultado do patch informado',
  'Path Does Not Exist': 'A rota não existe',
  'Payload must be a non-empty array of client updates':
    'O payload deve ser um array não vazio de atualizações de clientes',
  'Phone Number ID or FB Access Token is missing!':
    'Falta o Phone Number ID ou o FB Access Token!',
  'Phone number ID or access token is missing on the business profile.':
    'Falta o ID do número de telefone ou o token de acesso no perfil da empresa.',
  'Phone number ID or access token not found':
    'ID do número de telefone ou token de acesso não encontrado',
  'Phone number id or fb access token is missing!':
    'Falta o id do número de telefone ou o token de acesso do FB!',
  'Pick any\\n\\n1. Pizza\\n2. Pasta':
    'Escolha uma opção\\n\\n1. Pizza\\n2. Massa',
  'Please setup account first': 'Configure a conta primeiro',
  'Policy Bazar lead dispatched to LiveKit':
    'Lead da Policy Bazar enviado ao LiveKit',
  'Presigned URL generated': 'URL pré-assinada gerada',
  'Presigned download URL generated': 'URL de download pré-assinada gerada',
  'Presigned upload URL generated': 'URL de upload pré-assinada gerada',
  'Query executed': 'Consulta executada',
  'Query exported to S3': 'Consulta exportada para o S3',
  'Quick Replies added successfully':
    'Respostas rápidas adicionadas com sucesso',
  'Re-engagement message': 'Mensagem de reengajamento',
  'Real one': 'Um real',
  'Redirect link not found.': 'Link de redirecionamento não encontrado.',
  'Request Failed with Internal Server Error':
    'A solicitação falhou com Internal Server Error',
  'Retainer invoice activated.': 'Fatura de adiantamento ativada.',
  'rollout.enabled is required — agent settings have not been initialized yet':
    'rollout.enabled é obrigatório: a configuração do agente ainda não foi inicializada',
  'SIP call accepted': 'Chamada SIP aceita',
  'SIP call initiated': 'Chamada SIP iniciada',
  'SIP call rejected': 'Chamada SIP recusada',
  'SIP call terminated': 'Chamada SIP finalizada',
  'SIP call terminated successfully': 'Chamada SIP finalizada com sucesso',
  'SIP configuration removed': 'Configuração SIP removida',
  'SIP configured successfully': 'SIP configurado com sucesso',
  'SIP is not configured. Run setup first.':
    'O SIP não está configurado. Execute primeiro a configuração.',
  'SIP trunk not found on LiveKit. Re-run SIP setup (Settings → SIP Calling) to reconnect the trunk.':
    'O tronco SIP não foi encontrado no LiveKit. Execute novamente a configuração SIP (Configurações → Chamadas SIP) para reconectar o tronco.',
  'SMS channel is not yet available':
    'O canal de SMS ainda não está disponível',
  'Search query only contains unsupported characters':
    'A consulta de busca contém apenas caracteres não aceitos',
  'Send queue temporarily unavailable, retry after a few seconds':
    'A fila de envio está temporariamente indisponível, tente novamente em alguns segundos',
  'Session cleared successfully': 'Sessão limpa com sucesso',
  'Session has been logged out': 'A sessão foi encerrada',
  'Session info fetched': 'Informações da sessão obtidas',
  'Session logged out successfully': 'Sessão encerrada com sucesso',
  'Session not found': 'Sessão não encontrada',
  'Sessions retrieved successfully': 'Sessões obtidas com sucesso',
  'Settings updated': 'Configurações atualizadas',
  'Setup your Facebook account first!':
    'Configure primeiro a sua conta do Facebook!',
  'Short URL collision occured. Try again or increase length and try again.':
    'Ocorreu uma colisão de URL curta. Tente de novo ou aumente o comprimento e tente novamente.',
  'Short URL collision occurred. Please try again with a longer hash length.':
    'Ocorreu uma colisão de URL curta. Tente novamente com um comprimento de hash maior.',
  'Some employees do not exist!': 'Alguns funcionários não existem!',
  'Source and fallback template cannot be the same':
    'O modelo de origem e o modelo de fallback não podem ser o mesmo',
  'Stored attribute configuration could not be read':
    'Não foi possível ler a configuração de atributos armazenada',
  'Successfully Fetched Attributes': 'Atributos obtidos com sucesso',
  'Successfully added or updated webhook URL':
    'URL do webhook adicionada ou atualizada com sucesso',
  'Successfully added webhook': 'Webhook adicionado com sucesso',
  'Successfully created business api-key!':
    'Chave de API da empresa criada com sucesso!',
  'Successfully deleted clients': 'Clientes excluídos com sucesso',
  'Successfully deleted scheduled!': 'Agendamento excluído com sucesso!',
  'Successfully deleted session!': 'Sessão excluída com sucesso!',
  'Successfully deleted webhook': 'Webhook excluído com sucesso',
  'Successfully deleted webhook URL': 'URL do webhook excluída com sucesso',
  'Successfully fetched all businesses.':
    'Todas as empresas obtidas com sucesso.',
  'Successfully fetched all employees.':
    'Todos os funcionários obtidos com sucesso.',
  'Successfully fetched all orgs.':
    'Todas as organizações obtidas com sucesso.',
  'Successfully fetched analytics!': 'Análise obtida com sucesso!',
  'Successfully fetched call settings!':
    'Configurações de chamadas obtidas com sucesso!',
  'Successfully fetched form responses':
    'Respostas do formulário obtidas com sucesso',
  'Successfully fetched pricing analytics!':
    'Análise de preços obtida com sucesso!',
  'Successfully generated CSV file for Cars24 delivery report':
    'Arquivo CSV do relatório de entregas da Cars24 gerado com sucesso',
  'Successfully logged in!': 'Sessão iniciada com sucesso!',
  'Successfully previewed the flow!': 'Fluxo pré-visualizado com sucesso!',
  'Successfully queued messages': 'Mensagens colocadas na fila com sucesso',
  'Successfully retrieved campaign Stats.':
    'Estatísticas da campanha obtidas com sucesso.',
  'Successfully retrieved campaign list':
    'Lista de campanhas obtida com sucesso',
  'Successfully retrieved client attributes':
    'Atributos do cliente obtidos com sucesso',
  'Successfully retrieved client details':
    'Detalhes do cliente obtidos com sucesso',
  'Successfully retrieved client list': 'Lista de clientes obtida com sucesso',
  'Successfully retrieved group list': 'Lista de grupos obtida com sucesso',
  'Successfully retrieved message': 'Mensagem obtida com sucesso',
  'Successfully retrieved messages': 'Mensagens obtidas com sucesso',
  'Successfully scheduled messages!': 'Mensagens agendadas com sucesso!',
  'Successfully send read status!': 'Status de leitura enviado com sucesso!',
  'Successfully start heltarbot flow!':
    'Fluxo do heltarbot iniciado com sucesso!',
  'Successfully update jwt token': 'Token jwt atualizado com sucesso',
  'Successfully updated call settings!':
    'Configurações de chamadas atualizadas com sucesso!',
  'Successfully updated employee.': 'Funcionário atualizado com sucesso.',
  'Successfully updated org.': 'Organização atualizada com sucesso.',
  'Successfully updated the flow!': 'Fluxo atualizado com sucesso!',
  'Support email config fetched successfully.':
    'Configurações do e-mail de suporte obtidas com sucesso.',
  'Support email config updated successfully.':
    'Configurações do e-mail de suporte atualizadas com sucesso.',
  'Sure!': 'Claro!',
  'System prompt generated successfully':
    'Prompt do sistema gerado com sucesso',
  'Target business is in a different organisation.':
    'A empresa de destino está em uma organização diferente.',
  'Target business not found.': 'Empresa de destino não encontrada.',
  'Template analytics retrieved successfully from ClickHouse':
    'Análise de modelos obtida com sucesso do ClickHouse',
  'Template category updates fetched successfully':
    'Atualizações de categoria de modelos obtidas com sucesso',
  'Template cost analytics retrieved successfully':
    'Análise de custo por modelo obtida com sucesso',
  'Template details retrieved successfully from ClickHouse':
    'Detalhes do modelo obtidos com sucesso do ClickHouse',
  'Template message analytics retrieved successfully':
    'Análise de mensagens de modelo obtida com sucesso',
  'Testing custom error': 'Testando erro personalizado',
  "The 'OWNER' role must have 'permissionManagement' enabled.":
    "A função 'OWNER' deve ter 'permissionManagement' habilitado.",
  'The GSTIN has an unrecognized state code.':
    'O GSTIN tem um código de estado não reconhecido.',
  'This API is not accessible with an API key.':
    'Esta API não é acessível com uma chave de API.',
  'This account has been deleted. Please contact your administrator.':
    'Esta conta foi excluída. Entre em contato com o seu administrador.',
  'This action requires a logged-in session, not an API key.':
    'Esta ação exige uma sessão iniciada, não uma chave de API.',
  'This email address is already linked to another contact':
    'Este endereço de e-mail já está vinculado a outro contato',
  'This embed link has expired or was already used. Reopen it from your CRM.':
    'Este link incorporado expirou ou já foi utilizado. Abra-o novamente pelo seu CRM.',
  'Password is required to activate your account.':
    'É necessária uma senha para ativar a sua conta.',
  'This invite is invalid or has expired.':
    'Este convite não é válido ou expirou.',
  'Timed out while waiting for function update to finish':
    'A atualização da função excedeu o tempo limite',
  'Token and new password are required!':
    'O token e a nova senha são obrigatórios!',
  'Token invalid or expired!': 'Token inválido ou expirado!',
  'Token not provided': 'Token não fornecido',
  'Token successfully created.': 'Token criado com sucesso.',
  'Too many fields.': 'Campos demais.',
  'Too many files. Please upload fewer files.':
    'Arquivos demais. Envie menos arquivos.',
  'Too many parts in multipart data.': 'Partes demais nos dados multipart.',
  'Transaction history retrieved successfully':
    'Histórico de transações obtido com sucesso',
  'Transcript saved to call message':
    'Transcrição salva na mensagem da chamada',
  'Unable to dispatch Policy Bazar lead to LiveKit':
    'Não foi possível enviar o lead da Policy Bazar ao LiveKit',
  'Unexpected file field.': 'Campo de arquivo inesperado.',
  'Update Template is not supported. Please make new template.':
    'Não é possível atualizar o modelo. Crie um novo modelo.',
  'Updated widget allowed origins': 'Origens permitidas do widget atualizadas',
  'visitorId must be your own test visitor id':
    'visitorId deve ser seu próprio id de visitante de teste',
  'Upload failed': 'O upload falhou',
  Uploaded: 'Enviado',
  'User ID and token are required':
    'O ID de usuário e o token são obrigatórios',
  'User ID is required': 'O ID de usuário é obrigatório',
  'User not found': 'Usuário não encontrado',
  'VOICE_BOT_SECRET not configured': 'VOICE_BOT_SECRET não está configurado',
  'Valid businessId is required.': 'É necessário um businessId válido.',
  'Valid employee ID is required.': 'É necessário um ID de funcionário válido.',
  'Valid org ID is required.': 'É necessário um ID de organização válido.',
  'Valid orgId is required.': 'É necessário um orgId válido.',
  'Valid partner ID is required.': 'É necessário um ID de parceiro válido.',
  'Valid version number is required': 'É necessário um número de versão válido',
  'Voice bot test room ready': 'Sala de teste do bot de voz pronta',
  'Voice call fetched': 'Chamada de voz obtida',
  'Voice calls listed': 'Chamadas de voz listadas',
  'Wallet information retrieved successfully':
    'Informações da carteira obtidas com sucesso',
  'We could not create this account. It may already exist — try logging in.':
    'Não foi possível criar esta conta. Talvez ela já exista — tente fazer login.',
  'Webhook processed': 'Webhook processado',
  'Welcome!': 'Bem-vindo!',
  'What is your name?': 'Qual é o seu nome?',
  'WhatsApp notification sent successfully':
    'Notificação do WhatsApp enviada com sucesso',
  'Whatsapp api signUp again to run this operation':
    'Registre-se novamente na API do WhatsApp para executar esta operação',
  'You are not authorized to access this resource':
    'Você não está autorizado a acessar este recurso',
  'You can only fetch your own employee record.':
    'Você só pode consultar o seu próprio registro de funcionário.',
  'You can only grant access to businesses you can access.':
    'Você só pode conceder acesso a empresas às quais você tem acesso.',
  'You cannot create tags. You can directly update the tags options':
    'Você não pode criar etiquetas. Você pode atualizar diretamente as opções de etiquetas',
  'You do not have access to this business. Contact your account owner.':
    'Você não tem acesso a esta empresa. Entre em contato com o proprietário da sua conta.',
  'You do not have partner dashboard access.':
    'Você não tem acesso ao painel de parceiros.',
  'You do not have permission to log out other users.':
    'Você não tem permissão para encerrar a sessão de outros usuários.',
  'Your account has no business access. Please contact your account owner.':
    'Sua conta não tem acesso a nenhuma empresa. Entre em contato com o proprietário da sua conta.',
  'Your account is ready. You can now log in.':
    'Sua conta está pronta. Você já pode fazer login.',
  'Your admin access is read-only. This action is not permitted.':
    'Seu acesso de administrador é somente leitura. Esta ação não é permitida.',
  'Zoho customers fetched successfully.':
    'Clientes do Zoho obtidos com sucesso.',
  'Zoho estimate fetched successfully.':
    'Orçamento do Zoho obtido com sucesso.',
  'Zoho estimate not found.': 'Orçamento do Zoho não encontrado.',
  'Zoho estimates fetched successfully.':
    'Orçamentos do Zoho obtidos com sucesso.',
  'attribute parameter is missing in the request.':
    'Falta o parâmetro attribute na solicitação.',
  'businessId is required and must be a number.':
    'businessId é obrigatório e deve ser um número.',
  'businessId, clientWaNumber, and callUuid are required':
    'businessId, clientWaNumber e callUuid são obrigatórios',
  'businessIds must be an array.': 'businessIds deve ser um array.',
  'callId and either phoneNumberId or businessId are required':
    'callId e phoneNumberId ou businessId são obrigatórios',
  'callId is required': 'callId é obrigatório',
  'chatbotId and phoneNumberId or businessId are required':
    'chatbotId e phoneNumberId ou businessId são obrigatórios',
  'chatbotId is required': 'chatbotId é obrigatório',
  'clientWaNumber and businessId are required.':
    'clientWaNumber e businessId são obrigatórios.',
  'clientWaNumber and phoneNumberId are required.':
    'clientWaNumber e phoneNumberId são obrigatórios.',
  'clientWaNumber is required': 'clientWaNumber é obrigatório',
  'clientWaNumbers parameter is missing in the request.':
    'Falta o parâmetro clientWaNumbers na solicitação.',
  'codeZipBase64 payload is empty': 'O payload codeZipBase64 está vazio',
  'contactId is required': 'contactId é obrigatório',
  'employeeId is required': 'employeeId é obrigatório',
  'endDate must not be before startDate.':
    'endDate não deve ser anterior a startDate.',
  'expirationDays (1-30) is required when action=pin':
    'expirationDays (1-30) é obrigatório quando action=pin',
  'flowDefinition is required for flow chatbots':
    'flowDefinition é obrigatório para os bots de fluxo',
  'function not found for this org':
    'Função não encontrada para esta organização',
  'hasAccess must be a boolean.': 'hasAccess deve ser um booleano.',
  'invocation failed': 'A invocação falhou',
  'media.url must be a Heltar-hosted upload URL':
    'media.url deve ser uma URL de upload hospedada na Heltar',
  'name, chatbotId, and either phoneNumberId or businessId are required':
    'name, chatbotId e phoneNumberId ou businessId são obrigatórios',
  'oldattribute and newattribute in case of tags should be same.':
    'oldattribute e newattribute devem ser iguais no caso das etiquetas.',
  'orgId not found in JWT': 'orgId não encontrado no JWT',
  'recipientCount is required with finalPayloadFileUrl':
    'recipientCount é obrigatório com finalPayloadFileUrl',
  'registrationNo and mobileNumber are required':
    'registrationNo e mobileNumber são obrigatórios',
  'registrationNumber and mobile are required':
    'registrationNumber e mobile são obrigatórios',
  'roomName is required': 'roomName é obrigatório',
  'since must be an epoch timestamp': 'since deve ser um timestamp epoch',
  'startDate and endDate are required': 'startDate e endDate são obrigatórios',
  'startDate and endDate must be valid dates.':
    'startDate e endDate devem ser datas válidas.',
  'startDate and endDate query params are required (YYYY-MM-DD)':
    'Os parâmetros de consulta startDate e endDate (YYYY-MM-DD) são obrigatórios',
  'startDate must be before endDate': 'startDate deve ser anterior a endDate',
  'tags attribute canot be deleted.': 'O atributo tags não pode ser excluído.',
  'templateName and date are required': 'templateName e date são obrigatórios',
  'wamid query parameter is required':
    'O parâmetro de consulta wamid é obrigatório',
  'zohoEstimateId is required': 'zohoEstimateId é obrigatório',
  'zohoEstimateId is required.': 'zohoEstimateId é obrigatório.',
  'Failed to deploy code. Please try again.':
    'Não foi possível implantar o código. Tente novamente.',
  'Save your code before creating a version.':
    'Salve seu código antes de criar uma versão.',
  'Failed to create the version. Please try again.':
    'Não foi possível criar a versão. Tente novamente.',
  'Failed to download the code bundle. Please try again.':
    'Não foi possível baixar o pacote de código. Tente novamente.',
  'The deployment did not complete. Please try again.':
    'A implantação não foi concluída. Tente novamente.',
  'The function could not be created. Please check your configuration or try again.':
    'Não foi possível criar a função. Verifique sua configuração ou tente novamente.',
  'ROUTE_MOBILE_SYSTEM_USER_TOKEN is not configured':
    'ROUTE_MOBILE_SYSTEM_USER_TOKEN não está configurado',
  'Credit line attachment is not available for this sign-up type':
    'A vinculação de linha de crédito não está disponível para este tipo de cadastro',
  'Route Mobile system user token was rejected by Meta':
    'A Meta rejeitou o token de usuário do sistema da Route Mobile',
  'Failed to attach Route Mobile credit line for this business':
    'Não foi possível vincular a linha de crédito da Route Mobile para este negócio',
  'A credit line is already attached to this WhatsApp Business Account':
    'Esta conta do WhatsApp Business já tem uma linha de crédito vinculada',
  'Could not read the WhatsApp Business Account funding status from Meta':
    'Não foi possível ler o status de financiamento da conta do WhatsApp Business no Meta',
  'WhatsApp Business Account currency does not match the Route Mobile credit line currency':
    'A moeda da conta do WhatsApp Business não corresponde à moeda da linha de crédito da Route Mobile',
};
